export default __webpack_public_path__ + "static/media/215.68909380.png";